var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4439 30.2043C24.0123 30.2043 30.1476 24.0689 30.1476 16.5006C30.1476 8.93223 24.0123 2.79688 16.4439 2.79688C8.87559 2.79688 2.74023 8.93223 2.74023 16.5006C2.74023 24.0689 8.87559 30.2043 16.4439 30.2043Z",
    fill: "#181717",
    stroke: "#181717",
    strokeWidth: 2.74074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3783 9.92188H11.5116C10.6034 9.92188 9.86719 10.5109 9.86719 11.2374V21.7619C9.86719 22.4884 10.6034 23.0774 11.5116 23.0774H21.3783C22.2865 23.0774 23.0227 22.4884 23.0227 21.7619V11.2374C23.0227 10.5109 22.2865 9.92188 21.3783 9.92188Z",
    stroke: "white",
    strokeWidth: 1.64444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4451 19.7887C18.2615 19.7887 19.734 18.3162 19.734 16.4998C19.734 14.6834 18.2615 13.2109 16.4451 13.2109C14.6287 13.2109 13.1562 14.6834 13.1562 16.4998C13.1562 18.3162 14.6287 19.7887 16.4451 19.7887Z",
    stroke: "white",
    strokeWidth: 1.64444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.d895dd43950f1957c9a4ef1f6d7ae17f.svg";
export { ForwardRef as ReactComponent };